// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_gs-0";
export var buttonContainer = "_gs-3";
export var cancelButton = "_gs-4";
export var headerSection = "_gs-6";
export var headerTitle = "_gs-9";
export var messageSideLeft = "_gs-1";
export var messageSideRight = "_gs-2";
export var orderNumberContainer = "_gs-7";
export var orderNumberLabel = "_gs-8";
export var submitButton = "_gs-5";